module.exports = __webpack_public_path__ + "static/media/delete_list.f7e8292b.gif";